export const digitsOnly = (value) => String(value || '').replace(/\D/g, '');

export const formatCpfOrCnpj = (value) => {
  if (!value) return value;

  const onlyDigits = digitsOnly(value);

  if (onlyDigits.length <= 11) {
    if (onlyDigits.length === 11) {
      return onlyDigits.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
    }
    return onlyDigits;
  }

  const cnpjDigits = onlyDigits.slice(0, 14);
  if (cnpjDigits.length === 14) {
    return cnpjDigits.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  }

  return cnpjDigits;
};

export const validateCpfOrCnpj = (value) => {
  const digits = digitsOnly(value);

  if (digits.length === 11) {
    if (/^(\d)\1+$/.test(digits)) return false;

    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(digits.charAt(i), 10) * (10 - i);
    }
    let rest = 11 - (sum % 11);
    const digit1 = rest >= 10 ? 0 : rest;
    if (digit1 !== parseInt(digits.charAt(9), 10)) return false;

    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(digits.charAt(i), 10) * (11 - i);
    }
    rest = 11 - (sum % 11);
    const digit2 = rest >= 10 ? 0 : rest;
    if (digit2 !== parseInt(digits.charAt(10), 10)) return false;

    return true;
  }

  if (digits.length === 14) {
    if (/^(\d)\1+$/.test(digits)) return false;

    let length = digits.length - 2;
    let numbers = digits.substring(0, length);
    const digitsVerifiers = digits.substring(length);
    let sum = 0;
    let pos = length - 7;

    for (let i = length; i >= 1; i--) {
      sum += parseInt(numbers.charAt(length - i), 10) * pos;
      pos -= 1;
      if (pos < 2) pos = 9;
    }

    let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digitsVerifiers.charAt(0), 10)) return false;

    length += 1;
    numbers = digits.substring(0, length);
    sum = 0;
    pos = length - 7;

    for (let i = length; i >= 1; i--) {
      sum += parseInt(numbers.charAt(length - i), 10) * pos;
      pos -= 1;
      if (pos < 2) pos = 9;
    }

    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digitsVerifiers.charAt(1), 10)) return false;

    return true;
  }

  return false;
};
